import { Routes } from '@angular/router';
import { ErrorComponent } from './pages/error/error.component';
import { MsalCustom } from './Services/MsalCustom.service';
import { TermsofuseComponent } from './termsofuse/termsofuse.component';
import { PrivacyagreementComponent } from './PrivacyAgreement/privacyagreement.component';

export const routes: Routes = [
  { path: '', redirectTo: 'app', pathMatch: 'full' },
  {path: 'app', 
    loadChildren: () => import('../app/pages/initial-page/initial.module').then(mod => mod.initialRoutes)
    ,canActivate: [MsalCustom]
  },
   {
    path: 'terms',
    component: TermsofuseComponent,
    data: { breadcrumb: 'TermsofUse' },
  },
  // {
  //   path: 'privacy',
  //   component: PrivacyagreementComponent,
  //   data: { breadcrumb: 'PrivacyAgreement' },
  // },
  {
    path: 'privacy',
    loadComponent: () => import('../app/PrivacyAgreement/privacyagreement.component').then(mod => mod.PrivacyagreementComponent),
     data: { breadcrumb: 'PrivacyAgreement' },
  },
  { path: '**', component: ErrorComponent, 
    canActivate: [MsalCustom] 
  },
];

